import { useCallback, useState } from 'react';

export type SkinStage = 'default' | 'graceCommunication' | 'preroll';

type CurrentStageChecker<Stages extends string> = {
    checkIsStageCurrent: (...controlAvailabilityStages: Stages[]) => boolean;
};

type StageSwitchers<Stages extends string> = {
    [Stage in Stages as `switchTo${Capitalize<Stage & string>}Stage`]: () => void;
};

type Result = CurrentStageChecker<SkinStage> & StageSwitchers<SkinStage>;

export const useSkinStage = (initialStage: SkinStage = 'default'): Result => {
    const [stage, setStage] = useState<SkinStage>(initialStage);

    return {
        checkIsStageCurrent: useCallback(
            (...controlAvailabilityStages: SkinStage[]) =>
                controlAvailabilityStages.includes(stage),
            [stage]
        ),
        switchToDefaultStage: useCallback(() => setStage('default'), []),
        switchToGraceCommunicationStage: useCallback(() => setStage('graceCommunication'), []),
        switchToPrerollStage: useCallback(() => setStage('preroll'), []),
    };
};
